export const META_BUTTON_SIZE = {
    SM: 'sm',
    MD: 'md',
};

export const META_BUTTON_SIZES = Object.values(META_BUTTON_SIZE);
